import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminDocument = () => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);

  const fetchData = () => {
    fetch("https://stjosephweb.ilakshyaerp.in/api/documents")
      .then((res) => res.json())
      .then((res) => setData(Array.isArray(res) ? res : []));
  };

  useEffect(fetchData, []);

  const handleSubmit = async () => {
    if (!title) {
      alert("Enter document title ❌");
      return;
    }

    if (!file) {
      alert("Please choose file ❌");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("file", file);

    try {
      const res = await fetch(
        "https://stjosephweb.ilakshyaerp.in/api/documents/add",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await res.json();

      // ✅ SHOW BACKEND ERROR MESSAGE
      if (!res.ok) {
        alert(data.message || "Upload failed ❌");
        return;
      }

      // ✅ SUCCESS MESSAGE
      alert(data.message || "Uploaded successfully ✅");

      fetchData();
      setTitle("");
      setFile(null);
    } catch (error) {
      alert("Server error ❌");
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(
        `https://stjosephweb.ilakshyaerp.in/api/documents/${id}`,
        {
          method: "DELETE",
        }
      );

      const data = await res.json();

      alert(data.message || "Deleted successfully ✅");

      fetchData();
    } catch {
      alert("Delete failed ❌");
    }
  };

  return (
    <AdminLayout>
      <div className="notice-page">

        <div className="notice-card">
          <h2>Upload Document</h2>

          <input
            placeholder="File title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <input
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
          />

          <button onClick={handleSubmit}>
            Upload
          </button>
        </div>

        <div className="notice-table">
          <h2>All Documents</h2>

          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((d) => (
                <tr key={d.id}>
                  <td>{d.title}</td>

                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(d.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminDocument;